import React from 'react';
import queryString from 'query-string';
import { connect } from 'react-redux';
//import { withRouter } from 'react-router-dom';
import { Form } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { onErrorMsg } from '../../../actions/FlashMessage/FlashMessages';
import { setNavigateToMsg } from '../../../actions/Notifications/ScreenReaderInit';
import { setPageTitle } from '../../../actions/Page/PageAction';
import {
  fetchPreviewUser,
  getAddUserFormHeader,
  setPreviewUser,
  resetUserPreview,
} from '../../../actions/Users/UserAction';
import {
  ADMINISTRATOR_USER,
  ASSOCIATION_USER,
  INSTITUTION_USER,
  REPORT_USER,
  SPECIALTY_USER,
  SUPER_USER,
} from '../../../actionTypes/Users/UserActionType';
import Api from '../../../Api';
import Constants from '../../../Constants';
import { FormButtons, Loading } from '../../Common';
import CheckboxTree from '../../Common/Collapse/CheckboxTree';
import { hasAnyError, validateAny, validateEmail } from '../../Common/Errors/Errors';
import CheckList from '../../Common/Inputs/CheckList';
import Inputs from '../../Common/Inputs/Inputs';
import SelectInput from '../../Common/Inputs/SelectInput';
import { Switch } from '../../Common/Inputs/Switch';
import TypeaheadInput from '../../Common/Inputs/TypeaheadInput';
import TooltipQuestionIcon from '../../Common/Tooltip/TooltipQuestionIcon';
import SearchFrame from './SearchFrame';
import { sum } from 'ramda';
import { fetchSessionUserAvailableCASes, getAssociationSpecialty } from '../../../actions/Users/UserAction';
import { fetchAssociationsList } from '../../../actions/AssociationAndOrg/AssociationOrgAction';
import { getUserRoleList } from '../../../utils/permissions';
import './AddUser.scss';
import { compareIgnoreCase } from '../../../utils/helpers';
import withNavigate from '../../HOC/navigate';
import withLocation from '../../HOC/WithLocation';

const USER_ROLE_WITH_IDS = {
  1: { name: 'Super User', id: 1, title: SUPER_USER },
  2: { name: 'Organization Administrator', id: 2, title: ADMINISTRATOR_USER },
  3: { name: 'Organization Report User', id: 3, title: REPORT_USER },
  4: { name: 'Association User', id: 4, title: ASSOCIATION_USER },
  5: { name: 'Institution User', id: 5, title: INSTITUTION_USER },
  8: { name: 'Specialty User', id: 8, title: SPECIALTY_USER },
};

class AddUser extends React.Component {
  state = {
    username: '',
    given_name: '',
    family_name: '',
    internalUser: false,
    isUgmAllowed: false,
    clients: [],
    userRole: '',
    userRoleList: [],
    search: '',
    institutionId: '',
    totalCountOrganizations: 0,
    selectedOrganizationIds: [],
    selectedCasIds: [],
    searchAssociationSpecialtyList: [],
    specialtyCasList: [],
    selectedSpecialtyCasId: '',
    formInputsValidation: {},
    defaultIndex: null,
    showSelectedOrganizations: true,
    isBusy: false,
    isLoading: false,
    isSSOEnable: false,
    isUGMEnable: false,
    casOrgsSearch: [],
    casOrgsLoading: false,
    specialityUserOrgs: [],
  };

  constructor(props) {
    super(props);
    this.modalScrollRef = React.createRef();
    this.searchScrollRef = React.createRef();
    this.institutionRef = React.createRef();
    this.orgListRef = React.createRef();
  }

  async componentDidMount() {
    const { location, previewUser, loggedUserDetails, organisationListByClientId } = this.props;
    const { userRole } = loggedUserDetails;
    const userRoleList = getUserRoleList(userRole);

    const queryParams = queryString.parse(location.search);

    this.setState({ userRoleList });

    if (queryParams?.guid && queryParams?.guid !== previewUser.guid) {
      this.setState({ isLoading: true });
      this.props.fetchPreviewUser(queryParams.guid).then(() => {
        this.initForm();
        this.setState({ isLoading: false });
      });
    } else {
      this.setState({ isLoading: true });
      this.props.resetUserPreview();
      this.initForm();
      this.setState({ isLoading: false });
    }

    this.props.setPageTitle(this.getFormTitle());
    this.props.setNavigateToMsg(this.getFormTitle());
    this.props.getAssociationSpecialty();
    this.loadSpecialtyCasList();
  }

  loadSpecialtyCasList = async () => {
    try {
      const specialtyCasList = await this.props.fetchAssociationsList(0, true);
      this.setState({ specialtyCasList: specialtyCasList || [] });
    } catch (err) {
      console.error(err);
      this.setState({ specialtyCasList: [] });
    }
  };

  componentWillUnmount() {
    this.props.setPageTitle();
  }

  getUserData() {
    const { isEdit, isEnable, location, previewUser = {} } = this.props;
    // const queryParams = queryString.parse(location.search);
    const queryParams = queryString.parse(document.location.search);
    return isEdit || isEnable || queryParams?.guid ? previewUser : null;
  }

  initForm() {
    const { institutions = [], loggedUserDetails, institutionDetails } = this.props;
    const { userRole } = loggedUserDetails;
    const previewUser = this.getUserData();

    const institutionId = previewUser?.institution?.id || institutionDetails?.institutionClientId || null;
    const defaultIndex = institutions?.findIndex((x) => x.id === institutionId) ?? -1;
    const selectedOrganizationIds =
      previewUser?.casOrgs?.reduce((clientIDs, cas) => [...clientIDs, ...cas.clients.map((client) => client.id)], []) ||
      [];

    if (institutionId) {
      this.setState({ casOrgsLoading: true });
      fetchSessionUserAvailableCASes(institutionId).then((casOrgsSearch) => {
        const totalCountOrganizations = sum(casOrgsSearch.map((cas) => cas.clients.length));
        this.setState({ totalCountOrganizations, casOrgsSearch, casOrgsLoading: false });
      });
    } else {
      const casOrgsSearch = institutionDetails.casOrgs || [];
      const totalCountOrganizations = sum(casOrgsSearch.map((cas) => cas.clients.length));
      this.setState({ totalCountOrganizations, casOrgsSearch, casOrgsLoading: false });
    }

    if (!!previewUser?.email) {
      const { associationSpecialtyList } = this.props;
      this.setState({
        username: previewUser.email,
        given_name: previewUser.givenName,
        family_name: previewUser.familyName,
        userRole: previewUser.userRoleConstant,
        internalUser: previewUser.internalUser,
        isUgmAllowed: previewUser.isUgmAllowed,
        selectedCasIds: previewUser.casOrgs.map((cas) => cas.casId),
        defaultIndex,
        institutionId,
        selectedOrganizationIds,
        searchAssociationSpecialtyList:
          previewUser.userRoleConstant == SPECIALTY_USER
            ? associationSpecialtyList
                .filter((item1) => previewUser.casOrgs[0]?.clients.some((item2) => item2.id === item1.clientId))
                .map((item1) => item1.id)
            : [],
        selectedSpecialtyCasId:
          previewUser.userRoleConstant == SPECIALTY_USER ? previewUser.casOrgs?.[0]?.casId || '' : '',
      });
    }

    switch (userRole) {
      case ADMINISTRATOR_USER: {
        this.setState({
          userRole: previewUser?.userRoleConstant ?? REPORT_USER,
        });
        break;
      }
      case ASSOCIATION_USER: {
        this.setState({
          userRole: previewUser?.userRoleConstant ?? ASSOCIATION_USER,
        });
        break;
      }
      case INSTITUTION_USER: {
        this.setState({
          userRole: INSTITUTION_USER,
        });
        break;
      }
      case SUPER_USER: {
        break;
      }
      default: {
        break;
      }
    }
  }

  handleInputChange = (inputFields, value, valueParse) => {
    const { name } = inputFields;
    let { casOrgsArr } = this.state;
    let valueHolder = valueParse || value;

    switch (name) {
      case 'is_sso_enable':
        this.setState({ isSSOEnable: valueHolder });
        break;
      case 'is_ugm_enable':
        this.setState({ isUGMEnable: valueHolder });
        break;

      case 'given_name':
        this.setState({ given_name: valueHolder });
        break;
      case 'family_name':
        this.setState({ family_name: valueHolder });
        break;
      case 'username':
        this.setState({ username: valueHolder });
        break;
      case 'isUgmAllowed':
        this.setState({ isUgmAllowed: valueHolder });
        break;
      case 'internal':
        this.setState({ internalUser: valueHolder });
        break;
      case 'orgs':
        valueHolder = Number(valueHolder);
        casOrgsArr[inputFields.index].selectedOrg = valueHolder;
        this.setState({
          casOrgsArr,
        });
        break;
      case 'institution':
        if (valueHolder) {
          const institutionIdPosition = this.props.institutions.findIndex(
            (institutions) => institutions.id === valueHolder,
          );
          this.setState({ defaultIndex: institutionIdPosition, casOrgsLoading: true });
          fetchSessionUserAvailableCASes(valueHolder).then((casOrgsSearch) => {
            const totalCountOrganizations = sum(casOrgsSearch.map((cas) => cas.clients.length));
            this.setState({
              institutionId: valueHolder,
              totalCountOrganizations,
              casOrgsSearch,
              casOrgsLoading: false,
            });
          });
        } else {
          this.setState({
            institutionId: -1,
            selectedOrganizationIds: [],
            search: '',
          });
        }
        break;
      case 'userRole':
        const { selectedCasIds } = this.state;
        const user = inputFields.dataObj.find((u) => u.id == valueParse.id);
        if (user?.title === ASSOCIATION_USER && !selectedCasIds.length) {
          selectedCasIds.push(...this.props.association.filter((assCas) => selectedCasIds.indexOf(assCas.id) !== -1));
        }
        this.setState({
          userRole: user?.title,
          selectedSpecialtyCasId: user?.title === SPECIALTY_USER ? this.state.selectedSpecialtyCasId : '',
          searchAssociationSpecialtyList:
            user?.title === SPECIALTY_USER ? this.state.searchAssociationSpecialtyList : [],
        });
        if (user?.title === SPECIALTY_USER && !(this.state.specialtyCasList || []).length) {
          this.loadSpecialtyCasList();
        }
        break;
      case 'specialtyCas':
        this.setState({
          selectedSpecialtyCasId: valueHolder || '',
          searchAssociationSpecialtyList: [],
          search: '',
        });
        break;
      default:
        this.setState({
          [inputFields.name]: valueHolder,
        });
    }
  };

  submitForm = () => {
    const {
      selectedCasIds,
      selectedOrganizationIds,
      userRole,
      institutionId,
      username,
      given_name,
      family_name,
      casOrgsSearch,
      internalUser,
      isUgmAllowed,
      isSSOEnable,
      isUGMEnable,
      searchAssociationSpecialtyList,
    } = this.state;

    let newUserDetails = {
      email: username.toLowerCase().trim(),
      givenName: given_name,
      familyName: family_name,
      userRole,
      internalUser:
        this.props.loggedUserDetails.userRole !== SUPER_USER || userRole === SUPER_USER ? false : internalUser,
      isUgmAllowed: isUgmAllowed,
      isSSOEnabled: isSSOEnable,
      isUserMgmtEnabled: isUGMEnable,
      internalUser:
        this.props.loggedUserDetails.userRole !== SUPER_USER || userRole === SUPER_USER ? false : internalUser,
    };

    const formInputsValidation = {
      username: validateEmail(username),
      given_name: validateAny(given_name),
      family_name: validateAny(family_name),
      userRole: validateAny(userRole),
    };

    const isLoggedAsSU_ASSOC = [SUPER_USER, ASSOCIATION_USER].includes(this.props.loggedUserDetails.userRole);

    const clientsCount = sum(casOrgsSearch.map((cas) => cas.clients.length));

    switch (userRole) {
      case ASSOCIATION_USER: {
        newUserDetails.clients = selectedCasIds.map((id) => ({ id }));
        formInputsValidation.cas_ass_user = validateAny(selectedCasIds.length > 0);
        break;
      }
      case SPECIALTY_USER:
        const { associationSpecialtyList } = this.props;
        const { selectedSpecialtyCasId } = this.state;
        // newUserDetails.clients = searchAssociationSpecialtyList.map((clientId) => ({ clientId }));

        newUserDetails.clients = associationSpecialtyList
          .filter((item) => searchAssociationSpecialtyList.includes(item.id))
          .map((item) => ({ id: item.clientId }));
        //newUserDetails.specialityUserOrgs = searchAssociationSpecialtyList.map((id) => ({ id }));
        formInputsValidation.specialty_cas = validateAny(selectedSpecialtyCasId);
        formInputsValidation.sp_user_org = validateAny(searchAssociationSpecialtyList.length > 0);
        break;
      case ADMINISTRATOR_USER:
      case INSTITUTION_USER: {
        if (clientsCount === 1) {
          selectedOrganizationIds.push(casOrgsSearch[0].clients[0].id);
        }
        newUserDetails.clients = selectedOrganizationIds.map((id) => ({ id }));
        formInputsValidation.organizations = validateAny(selectedOrganizationIds.length > 0);
        break;
      }
      case REPORT_USER: {
        if (clientsCount === 1) {
          selectedOrganizationIds.push(casOrgsSearch[0].clients[0].id);
        }
        newUserDetails.clients = selectedOrganizationIds.map((id) => ({ id }));
        formInputsValidation.institution = isLoggedAsSU_ASSOC ? validateAny(institutionId) : '';
        formInputsValidation.organizations = validateAny(selectedOrganizationIds.length > 0);
        break;
      }
      default: {
        break;
      }
    }

    this.setState({ formInputsValidation });
    const hasErrors = hasAnyError(formInputsValidation);

    hasErrors || this.state.isBusy ? void 0 : this.submitUserChange(newUserDetails);
  };

  async submitUserChange(body) {
    const { username } = this.state;
    const previewUser = this.getUserData();
    const api = new Api();
    const url = [Constants.apiUrls.usersList, previewUser?.guid].filter((v) => !!v).join('/');
    const apiFn = previewUser?.guid ? api.putData.bind(api, url, { body }) : api.postData.bind(api, url, { body });
    this.setState({ isBusy: true });
    try {
      const resp = await apiFn();
      const redirectURL = '/userDetails?guid=' + resp.guid;
      this.props.setPreviewUser(resp);
      this.props.navigate(redirectURL, {
        state: {
          statusMessage: this.props.isEnable
            ? `${username} has been successfully enabled.`
            : `${username} saved successfully!`,
        },
      });
    } catch (err) {
      this.setState({ isBusy: false });
      console.error(err);
      let errorMsg = '';
      if (err.response && err.response.data.error) {
        errorMsg = err.response.data.error;
      }
      this.props.onErrorMsg(errorMsg);
    }
  }

  onSelectOrganization = (organization) => {
    const { selectedOrganizationIds } = this.state;
    const idx = selectedOrganizationIds.findIndex((id) => id === organization.id);
    const newSelectedOrganizationIds =
      idx === -1
        ? [...selectedOrganizationIds, organization.id]
        : [...selectedOrganizationIds.slice(0, idx), ...selectedOrganizationIds.slice(idx + 1)];
    this.setState({ selectedOrganizationIds: newSelectedOrganizationIds });
  };

  searchCases() {
    const { search } = this.state;

    if (search.length <= 1) return this.props.association;

    return this.props.association.filter((item) => {
      return item.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
    });
  }
  getSpecialtiesForSelectedCas = () => {
    const { selectedSpecialtyCasId } = this.state;
    const associationSpecialtyList = this.props.associationSpecialtyList || [];
    if (!selectedSpecialtyCasId) {
      return [];
    }
    return associationSpecialtyList.filter(
      (item) => String(item.casId) === String(selectedSpecialtyCasId),
    );
  };

  searchOrgList() {
    const { search } = this.state;
    const specialtiesForCas = this.getSpecialtiesForSelectedCas();

    if (search.length <= 1) return specialtiesForCas;

    return specialtiesForCas.filter((item) => {
      return item.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
    });
  }
  searchCasesOrganizations() {
    const { search, casOrgsSearch } = this.state;

    if (search.length <= 1) {
      return casOrgsSearch;
    }

    return casOrgsSearch.filter((item) => {
      let foundSelected = false;
      if (item.name.toLowerCase().indexOf(search.toLowerCase()) !== -1) {
        foundSelected = true;
      }
      item.clients.forEach((c) => {
        if (c.name.toLowerCase().indexOf(search.toLowerCase()) !== -1) {
          foundSelected = true;
        }
      });

      return foundSelected;
    });
  }

  onInputSearchChange = (input, value) => {
    this.setState({ search: value });
  };

  renderSearchControls() {
    const { search, userRole, casOrgsSearch } = this.state;
    const { isEdit, loggedUserDetails } = this.props;
    const disabledInputs = loggedUserDetails.userRole !== SUPER_USER && isEdit;
    const loggedAs = loggedUserDetails.userRole;
    const singleCASOnly = casOrgsSearch.length === 1 && casOrgsSearch[0].clients.length === 1;
    switch (userRole) {
      case ASSOCIATION_USER: {
        const searchedCases = this.searchCases();
        return (
          <SearchFrame
            id={'findCasInput'}
            searchScrollRef={this.searchScrollRef}
            title="CAS"
            selectedTitle="CAS"
            onInputSearchChange={this.onInputSearchChange}
            search={search}
            visibleCases={searchedCases}
            errorMessages={this.state.formInputsValidation.cas_ass_user}
            countSelectedItems={this.state.selectedCasIds.length}
            totalCountItems={this.props.association.length}
            clearAll={() => {
              this.setState({ selectedCasIds: [] });
            }}
            selectAll={() => {
              const selectedCasIds = this.props.association.map((cas) => cas.id);
              this.setState({ selectedCasIds, search: '' });
            }}>
            <CheckList
              classNames="col-sm-12 checklist-container"
              items={searchedCases}
              highlightSearch={search}
              selectedIds={this.state.selectedCasIds}
              onSelectCheckbox={(item) => {
                const selectedCasIds = [...this.state.selectedCasIds];
                const idx = selectedCasIds.indexOf(item.id);
                const newCasList =
                  idx === -1
                    ? [...selectedCasIds, item.id]
                    : [...selectedCasIds.slice(0, idx), ...selectedCasIds.slice(idx + 1)];
                this.setState({ selectedCasIds: newCasList });
              }}
            />
          </SearchFrame>
        );
      }
      case SPECIALTY_USER: {
        const specialtiesForCas = this.getSpecialtiesForSelectedCas();
        const searchedOrgList = this.searchOrgList();
        return (
          <SearchFrame
            id={'findOrgInput'}
            searchScrollRef={this.orgListRef}
            title="Speciality"
            selectedTitle="Speciality"
            onInputSearchChange={this.onInputSearchChange}
            search={search}
            visibleCases={searchedOrgList}
            errorMessages={this.state.formInputsValidation.sp_user_org}
            countSelectedItems={this.state.searchAssociationSpecialtyList.length}
            totalCountItems={specialtiesForCas.length}
            clearAll={() => {
              this.setState({ searchAssociationSpecialtyList: [] });
            }}
            selectAll={() => {
              const searchAssociationSpecialtyList = specialtiesForCas.map((itm) => itm.id);
              this.setState({ searchAssociationSpecialtyList, search: '' });
            }}>
            <CheckList
              classNames="col-sm-12 checklist-container"
              items={searchedOrgList}
              highlightSearch={search}
              selectedIds={this.state.searchAssociationSpecialtyList}
              onSelectCheckbox={(item) => {
                const searchAssociationSpecialtyList = [...this.state.searchAssociationSpecialtyList];
                const idx = searchAssociationSpecialtyList.indexOf(item.id);
                const newCasList =
                  idx === -1
                    ? [item.id]
                    : [
                        ...searchAssociationSpecialtyList.slice(0, idx),
                        ...searchAssociationSpecialtyList.slice(idx + 1),
                      ];
                this.setState({ searchAssociationSpecialtyList: newCasList });
              }}
            />
          </SearchFrame>
        );
        break;
      }
      case SUPER_USER: {
        break;
      }
      default: {
        const searchedCasesOrganizations = this.searchCasesOrganizations();
        return userRole ? (
          <div>
            {loggedAs === SUPER_USER ? (
              <TypeaheadInput
                disabled={disabledInputs}
                defaultIndex={this.state.defaultIndex}
                id={'findInstitutionInput'}
                refProps={this.institutionRef}
                onInputChange={this.handleInputChange}
                labelKey="name"
                errorMessages={this.state.formInputsValidation.institution}
                required="required"
                title="Institution"
                name="institution"
                type="institution"
                dataObj={this.props.institutions}
                value={this.state.institutionId}
              />
            ) : null}
            {this.state.institutionId ||
            ([ADMINISTRATOR_USER, INSTITUTION_USER].includes(loggedAs) && !singleCASOnly) ? (
              <SearchFrame
                id={'findOrgInput'}
                searchScrollRef={this.searchScrollRef}
                title="CAS/Organization"
                selectedTitle="organizations"
                onInputSearchChange={this.onInputSearchChange}
                search={search}
                visibleCases={searchedCasesOrganizations}
                totalCountItems={this.state.totalCountOrganizations}
                errorMessages={this.state.formInputsValidation.organizations}
                countSelectedItems={this.state.selectedOrganizationIds.length}
                clearAll={() => {
                  this.setState({ selectedOrganizationIds: [] });
                }}
                selectAll={() => {
                  const selectedOrganizationIds = [];
                  casOrgsSearch.forEach((cas) => cas.clients.forEach((orgs) => selectedOrganizationIds.push(orgs.id)));
                  this.setState({
                    selectedOrganizationIds,
                    search: '',
                    showSelectedOrganizations: !this.state.showSelectedOrganizations,
                  });
                }}>
                <CheckboxTree
                  isBusy={this.state.casOrgsLoading}
                  isActiveDDMenu={true}
                  hasFocus={false}
                  highlightSearch={search}
                  nodes={searchedCasesOrganizations}
                  showAllSelected={this.state.showSelectedOrganizations}
                  selectedIds={this.state.selectedOrganizationIds}
                  onSelectCheckbox={this.onSelectOrganization}
                  onSelectLastElement={() => {
                    // auto scroll for last element
                    setTimeout(() => {
                      const scrollElement = this.searchScrollRef.current;
                      scrollElement.scrollTop = scrollElement.scrollHeight;
                    }, 10);
                  }}
                />
              </SearchFrame>
            ) : null}
          </div>
        ) : null;
        break;
      }
    }

    return void 0;
  }

  getFormTitle() {
    const { isEdit, isEnable, loggedUserDetails } = this.props;
    return isEnable ? 'Enable User' : isEdit ? 'Edit User' : getAddUserFormHeader(loggedUserDetails.userRole);
  }

  getFormSubmitButtonLabel() {
    const { isEdit, isEnable } = this.props;
    return isEnable ? 'Enable' : isEdit ? 'Save' : 'Add';
  }
  checkAssocAndAdminUserAccess() {
    const { loggedUserDetails } = this.props;
    if (
      [ADMINISTRATOR_USER, ASSOCIATION_USER].includes(loggedUserDetails.userRoleConstant) &&
      compareIgnoreCase(loggedUserDetails.userManagementAccess, 'True')
    ) {
      return true;
    } else return false;
  }
  render() {
    const { username, family_name, given_name, userRole, userRoleList, searchAssociationSpecialtyList } = this.state;
    const { isEdit, loggedUserDetails, userRolesOptions, associationSpecialtyList } = this.props;
    const loggedAs = loggedUserDetails.userRole;
    const previewUser = this.getUserData();
    const formTitle = this.getFormTitle();
    const buttonTitle = this.getFormSubmitButtonLabel();
    const disabledInputFirstName = loggedAs !== SUPER_USER && isEdit;
    const disabledInputLastName = loggedAs !== SUPER_USER && isEdit;
    const disabledInputEmail = !!previewUser?.guid;
    const { isUgmAllowed, isSSORequired } = loggedUserDetails;
    const isInternalFlagHidden = loggedAs !== SUPER_USER || userRole === SUPER_USER;
    return (
      <React.Fragment>
        <div tabIndex={-1} className="pTop-45 init-focus__hidden">
          <div className={'add-user-container'}>
            <Loading show={this.state.isLoading} backdrop classNames={['loading-user-banner']} />
            <div className="mobile_margin md-container modalForm fontSm-15">
              <Form disabled className="add-user-form margin-center">
                <div className="md-title">
                  <h1 className="form-title-center" id="app_page_title">
                    {formTitle}
                  </h1>
                </div>

                <div ref={this.modalScrollRef} className="scroll-container">
                  <h2 className="heading-h6-20">New User Information</h2>

                  <Inputs
                    onInputChange={this.handleInputChange}
                    errorMessages={this.state.formInputsValidation.given_name}
                    required="required"
                    title="First Name"
                    name="given_name"
                    autoComplete="given-name"
                    id="firstName"
                    placeholder="First Name"
                    disabled={disabledInputFirstName}
                    value={given_name}
                  />

                  <Inputs
                    onInputChange={this.handleInputChange}
                    errorMessages={this.state.formInputsValidation.family_name}
                    required="required"
                    title="Last Name"
                    name="family_name"
                    autoComplete="family-name"
                    id="lastName"
                    placeholder="Last Name"
                    disabled={disabledInputLastName}
                    value={family_name}
                  />

                  <Inputs
                    onInputChange={this.handleInputChange}
                    errorMessages={this.state.formInputsValidation.username}
                    required="required"
                    title="Email"
                    autoComplete="email"
                    name="username"
                    id="username"
                    placeholder="username"
                    disabled={disabledInputEmail}
                    value={username}
                  />

                  {userRolesOptions.length >= 2 && (
                    <SelectInput
                      onInputChange={this.handleInputChange}
                      errorMessages={this.state.formInputsValidation.userRole}
                      required="required"
                      title="Role"
                      name="userRole"
                      idOption={false}
                      idKey={'title'}
                      defaultValue={true}
                      dataObj={userRolesOptions}
                      isEdit={isEdit}
                      value={
                        isEdit
                          ? JSON.stringify(userRolesOptions.find((u) => USER_ROLE_WITH_IDS[u.id]?.title == userRole))
                          : userRole
                      }
                    />
                  )}
                  {userRole == SPECIALTY_USER && (
                    <SelectInput
                      onInputChange={this.handleInputChange}
                      errorMessages={this.state.formInputsValidation.specialty_cas}
                      required="required"
                      title="CAS"
                      name="specialtyCas"
                      idOption={true}
                      defaultValue={true}
                      dataObj={this.state.specialtyCasList}
                      value={this.state.selectedSpecialtyCasId || ''}
                      disabled={isEdit && loggedAs !== SUPER_USER}
                    />
                  )}
                </div>

                {this.renderSearchControls()}

                <Inputs
                  onInputChange={this.handleInputChange}
                  title="Internal only"
                  id="internal"
                  name="internal"
                  unlinkLabel
                  defaultValue={this.state.internalUser}
                  showCheckLabels
                  labelTooltip={
                    <TooltipQuestionIcon
                      textDisplay={`Switch the toggle key <b>On</b> if this is a test or demonstration account. This ensures the account is private and viewable only to Liaison Super Users`}></TooltipQuestionIcon>
                  }
                  renderInput={(props) => <Switch {...props} />}
                  hidden={isInternalFlagHidden}
                />
                <Inputs
                  onInputChange={this.handleInputChange}
                  title="User Management Access"
                  id="user-management-access"
                  name="isUgmAllowed"
                  unlinkLabel
                  defaultValue={this.state.isUgmAllowed}
                  showCheckLabels
                  labelTooltip={
                    <TooltipQuestionIcon
                      textDisplay={`Switch the toggle key <b>On</b> if you want to provide User Management Access.`}></TooltipQuestionIcon>
                  }
                  renderInput={(props) => <Switch {...props} />}
                  hidden={
                    ![ADMINISTRATOR_USER, ASSOCIATION_USER, SUPER_USER].includes(loggedAs) ||
                    this.state.userRole === SUPER_USER ||
                    !this.checkAssocAndAdminUserAccess()
                  }
                />

                {/***SSO USER TOggle Button */}
                {isSSORequired && (
                  <Inputs
                    onInputChange={this.handleInputChange}
                    title="SSO Enable"
                    id="is_sso_enable"
                    name="is_sso_enable"
                    unlinkLabel
                    defaultValue={this.state.isSSOEnable}
                    showCheckLabels
                    labelTooltip={
                      <TooltipQuestionIcon
                        textDisplay={`Switch the toggle key <b>On</b> to Enable SSO login for this user.`}></TooltipQuestionIcon>
                    }
                    renderInput={(props) => <Switch {...props} />}
                    hidden={loggedAs !== SUPER_USER || this.state.userRole === SUPER_USER}
                  />
                )}

                {isUgmAllowed && (
                  <Inputs
                    onInputChange={this.handleInputChange}
                    title="UGM Enable"
                    id="is_ugm_enable"
                    name="is_ugm_enable"
                    unlinkLabel
                    defaultValue={this.state.isUGMEnable}
                    showCheckLabels
                    labelTooltip={
                      <TooltipQuestionIcon
                        textDisplay={`Switch the toggle key <b>On</b> to Enable UGM for this user.`}></TooltipQuestionIcon>
                    }
                    renderInput={(props) => <Switch {...props} />}
                    hidden={loggedAs !== SUPER_USER || this.state.userRole === SUPER_USER}
                  />
                )}

                {/***SSO USER Toggle Button End */}
                <FormButtons
                  isBusy={this.state.isBusy}
                  submitLabel={buttonTitle}
                  onSubmit={this.submitForm}
                  onCancel={this.props.isEdit ? `/userDetails?guid=${this.props.userGuid}` : '/users'}
                  wrapperClassNames={['mTop-40']}
                  extraButtonProps={{
                    id: 'button-submit',
                    'data-testid': 'button-submit',
                  }}
                />
              </Form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    institutions: state.Institutions.institutions,
    association: state.Association.association,
    institutionDetails: state.AppSession.institutionDetails,
    loggedUserDetails: state.AppSession.userDetails,
    previewUser: state.Users.previewUser,
    userRolesOptions: state.Users.filterOptions.userRoles,
    organisationListByClientId: state.Users.organisationListByClientId,
    associationSpecialtyList: state.Users.associationSpecialtyList,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getAssociationSpecialty,
      fetchAssociationsList,
      fetchPreviewUser,
      resetUserPreview,
      onErrorMsg,
      setNavigateToMsg,
      setPageTitle,
      setPreviewUser,
    },
    dispatch,
  );
}

//export default connect(mapStateToProps, matchDispatchToProps)(withRouter(AddUser));
export default connect(mapStateToProps, matchDispatchToProps)(withLocation(withNavigate(AddUser)));
